module.exports = __webpack_public_path__ + "img/high-border.5cab0730.png";